import dynamic from 'next/dynamic'
import React from 'react'

const AceEditor = dynamic(
  async () => {
    const reactAce = await import('react-ace')
    await import('ace-builds/src-noconflict/mode-html')
    await import('ace-builds/src-noconflict/theme-textmate')
    await import('ace-builds/src-noconflict/ext-language_tools')
    const ace = await import('ace-builds/src-noconflict/ace')
    ace.config.setModuleUrl(
      'ace/mode/html_worker',
      `${process.env.NEXT_PUBLIC_CLOUDFRONT_SHARED}/ace-build/worker-html.js`,
    )
    ace.config.setModuleUrl(
      'ace/snippets/html',
      `${process.env.NEXT_PUBLIC_CLOUDFRONT_SHARED}/ace-build/html.js`,
    )
    return reactAce
  },
  {
    loading: () => (
      <div className="flex animate-pulse flex-col gap-7  lg:gap-10 ">
        <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[144px] lg:flex-row lg:gap-10">
          <div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div>
        </div>
      </div>
    ),
    ssr: false,
  },
)
export default AceEditor
